import { TokenData } from "./tokenized";

const template = document.createElement("template");
template.innerHTML = `
      <style>
      :host {
          display: inline-block;
      }
      .container {
        padding: 0 6px;
        box-sizing: border-box;
        min-width: 20px;
        transition: box-shadow 200ms;
        border-right: 1px solid #ccc;
        display: inline-block;
        white-space: nowrap;
      }
      i {
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        line-height: 1;
        padding: 0.25rem 0  0.25rem  0.5rem;
        user-select: none;
      }

       i::before {
        content: '\\f410';
        font-family: 'Font Awesome 5 Free';
        // margin:0px 0px 0px 10px;
        // font-size: 80%;
        color: #0066A1;
      }
      </style>
      <div class="container"><slot></slot><i></i></div>
    `;

export class TextTokenElement extends HTMLElement {
  private _shadowRoot: ShadowRoot;
  private _data;
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this.render();
  }

  private render() {
    this._shadowRoot.innerHTML = "";
    this._shadowRoot.appendChild(template.content.cloneNode(true));
    this._shadowRoot.querySelector("i").addEventListener("click", () => this.dispatchEvent(new CustomEvent(
      "removeToken",
      { bubbles: true },
    )));

    if (this.hasAttribute("readonly")) {
      this._shadowRoot.querySelector("i").style.display = "none";
    }
  }

  static get observedAttributes() { return ["readonly"]; }

  private attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }

  set data(data: TokenData) {
    this._data = data;
    this.innerHTML = data.texts.join("/");
    this.title = data.tooltip;
  }

  get data() {
    return this._data;
  }
}

export function initComposedTextTokenWebComponent() {
  window.customElements.define("s6-composed-text-token", TextTokenElement);
}
